import { HTMLAttributes, ReactNode } from "react";
import cn from "clsx";

// KpiCard — grosse Kennzahl (Lexend via font-numeric) + Label. Nur Tokens
// (Card-Flaeche/Border/Radius --radius-card). Fuer die KPI-Reihe der Aufgaben-
// Ansicht (und wiederverwendbar app-weit).
export interface KpiCardProps extends HTMLAttributes<HTMLDivElement> {
  value: ReactNode;
  label: ReactNode;
}

export function KpiCard({ value, label, className, ...rest }: KpiCardProps) {
  return (
    <div
      className={cn(
        "bg-surface border border-border rounded-card shadow-sm px-[18px] py-4",
        className,
      )}
      {...rest}
    >
      <div className="font-numeric text-[1.9rem] leading-none font-semibold tabular-nums tracking-tight text-text">
        {value}
      </div>
      <div className="mt-2 text-[0.8rem] text-text-2">{label}</div>
    </div>
  );
}

export default KpiCard;
